import { CustomerMobileLoginConfiguration } from '@lumapps/customer/types';
import { isFeatureEnabled } from '@lumapps/features';
import { createSelector } from '@lumapps/redux/reselect';

import { QR_CODE_LOGIN, CHECK_IN } from '../constants';

export const getMobileLoginConfigurationForm = (state: BackOfficeStore) => state?.mobile?.login || {};

export const isMobileLoginConfigurationLoading = createSelector(
    getMobileLoginConfigurationForm,
    (login: CustomerMobileLoginConfiguration) => login?.isLoading || false,
);

export const isQrCodeLoginFeatureEnabled = isFeatureEnabled(QR_CODE_LOGIN);
export const isCheckInEnabled = isFeatureEnabled(CHECK_IN);
